/* eslint-disable */
import gsap from 'gsap';
import Draggable from 'gsap/Draggable';

gsap.registerPlugin( Draggable );

export {
    gsap,
    Draggable
};
